import * as React from 'react'

import { IconProps } from '@zet/design-system/icons'
import Svg, { Path } from 'react-native-svg'

const SelfEmployed = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg width={`${size}px`} height={`${size}px`} viewBox="0 0 20 20" {...props}>
    <Path
      d="M16.922 3.563v1.406c0 .393-.31.703-.703.703h-.703v-2.11a.696.696 0 0 0-.704-.703H9.189a.696.696 0 0 0-.704.704v2.109h-.703a.696.696 0 0 1-.703-.703V3.562c0-1.167.942-2.109 2.11-2.109h5.624c1.168 0 2.11.942 2.11 2.11Z"
      fill="#AAD5FF"
    />
    <Path
      d="M14.813 2.86H12V1.452h2.813c1.167 0 2.109.942 2.109 2.11v1.406c0 .393-.31.703-.703.703h-.703v-2.11a.696.696 0 0 0-.704-.703Z"
      fill="#389CFF"
    />
    <Path
      d="M24 4.969v15.469c0 1.167-.942 2.109-2.11 2.109H2.11A2.107 2.107 0 0 1 0 20.437V4.97a.69.69 0 0 1 .211-.492l3.586 8.072h16.406l3.586-8.072c.127.126.211.295.211.492Z"
      fill="#BFDFFF"
    />
    <Path
      d="M24 4.969v15.469c0 1.167-.942 2.109-2.11 2.109H12v-9.998h8.203l3.586-8.072c.127.126.211.295.211.492Z"
      fill="#A3D1FF"
    />
    <Path
      d="m23.789 4.477-2.18 8.071a2.106 2.106 0 0 1-2.039 1.561H4.43a2.106 2.106 0 0 1-2.04-1.56L.21 4.476a.69.69 0 0 1 .493-.211h22.594a.69.69 0 0 1 .492.21Z"
      fill="#D1E8FF"
    />
    <Path
      d="m23.789 4.477-2.18 8.071a2.106 2.106 0 0 1-2.039 1.561H12V4.266h11.297a.69.69 0 0 1 .492.21Z"
      fill="#60AFFF"
    />
    <Path
      d="M14.813 12H9.186a.696.696 0 0 0-.703.703v2.813c0 .393.31.703.704.703h5.624c.394 0 .704-.31.704-.703v-2.813a.696.696 0 0 0-.704-.703Z"
      fill="#fff"
    />
    <Path
      d="M15.516 12.703v2.813c0 .393-.31.703-.704.703H12V12h2.813c.393 0 .703.31.703.703Z"
      fill="#DCEDFF"
    />
  </Svg>
)

export default SelfEmployed
